import CopyButton from "../CopyButton";

interface CopyableCellProps {
  value: any;
}

const CopyableCell: React.FC<CopyableCellProps> = ({ value }) => {
  if (value === null || value === undefined || value === "") return null;
  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        maxWidth: "100%",
        gap: 4,
      }}
    >
      <span
        style={{
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          minWidth: 0,
        }}
        title={String(value)}
      >
        {value}
      </span>
      <CopyButton value={value} style={{ marginLeft: 0, flexShrink: 0 }} />
    </span>
  );
};

export default CopyableCell;
